import { LanguageCode } from 'translations/Language'
import new_de_landing_img from 'assets/img/landing/new-landing-de.png'
import new_en_landing_img from 'assets/img/landing/new-landing-en.png'
import new_es_landing_img from 'assets/img/landing/new-landing-es.png'
import new_fr_landing_img from 'assets/img/landing/new-landing-fr.png'
import new_nl_landing_img from 'assets/img/landing/new-landing-nl.png'

const images: Record<string, string> = {
  [LanguageCode.EN]: new_en_landing_img,
  [LanguageCode.DE]: new_de_landing_img,
  [LanguageCode.ES]: new_es_landing_img,
  [LanguageCode.FR]: new_fr_landing_img,
  [LanguageCode.NL]: new_nl_landing_img,
}

/**
 * Retrieves the landing image URL based on the provided language code.
 *
 * @param language - The language code (e.g., 'EN', 'FR', 'ES') for which to get the landing image.
 * @returns The URL of the landing image corresponding to the specified language, or the English image if the language is not found.
 */
export const getLandingImage = (language: string): string => {
  return images[language] || images.en // Default to English if language not found
}
